import React, {useEffect, useState,} from "react";
import {BackIcon} from "../../../../assets/icons/profileIcons";
import {useNavigate, useParams} from "react-router-dom";
import {Col, notification, Row,} from "antd";
import {AnniversaryIcon, CakeIcon,} from "../../../../assets/icons/sidebarIcons";
import DescriptionInput from "../../../components/common/description-field/DescriptionField";
import {Form} from "react-bootstrap";
import {Controller, useForm} from "react-hook-form";
import {checkEmptySpaces, maxLength, Required,} from "../../../utils/patterns";
import ThemeButton from "../../../components/common/theme-button/ThemeButton";
import {RoundedCheck,} from "../../../../assets/icons/defaultIcons";
import {CoachingClientById, CreateCoachSessions,} from "../../../services/coaching.service";
import {formateDate} from "../../../utils/constant";
import ThemeDatePicker from "../../../components/common/date-picker/ThemeDatePicker";
import ClientNoteDetailsSkeleton from "../../skeletons/coaching/ClientNoteDetailsSkeleton";
import DemoImage from "../../../../assets/images/d-image.png";

const AddNote = () => {
    let { id } = useParams();
    let navigate = useNavigate();
    const [sessionEdit, setSessionEdit] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [clientData, setClientData] = useState(null);
    const [renderContent, setRenderContent] = useState(false);
    const [loader,setLoader] = useState(false)
    let todayData = new Date();

    const {
        handleSubmit,
        reset,
        setValue,
        formState: { errors },
        control,
        clearErrors,
        watch,
    } = useForm({
        mode: "onChange",
    });

    const onSubmit = async (data) => {
        setLoader(true)
        let payload = {
            clientId: id,
            coachingStart: data?.start_date,
            coachingEnd: data?.end_date,
            // anniversary: data?.aniversary_date,
            sessionNote: data?.session_note,
            coachNote: data?.coach_note,
            actionItems: data?.action_items,
        };
        try {
            let res = await CreateCoachSessions(payload);
            if (res?.data?.data?.status) {
                notification.success({
                    message: "Success",
                    description: res?.data?.data?.message,
                    placement: "topRight",
                    icon: <RoundedCheck />,
                    duration: 2,
                });
            }
        } catch (error) {
            console.log("ThisIsErr", error);
            console.log("ThisIsErr2", error?.response);
        } finally {
            setSessionEdit(null);
            setRenderContent(!renderContent);
            reset();
            setLoader(false)
            navigate(`/coaching/client-details/${id}`)
        }
    };

    const HandleGetClientById = async () => {
        let res = await CoachingClientById(id);
        setClientData(res?.data?.data?.data);
        setIsLoading(false);
    };

    useEffect(() => {
        setIsLoading(true);
        HandleGetClientById();
    }, []);

    const HandleBack = () => {
        navigate(-1);
    };

    if (isLoading) {
        return <ClientNoteDetailsSkeleton/>;
    }

    return (
        <>
            <Form onSubmit={handleSubmit(onSubmit)}>
                <div className="main_div_client_details">
                    <div className="inner_div">
                        <div className="header">
              <span onClick={HandleBack}>
                <BackIcon />
              </span>
                            <h3>{clientData?.fullName}</h3>
                        </div>

                        <Row gutter={[16, 16]} style={{ marginTop: "20px" }}>
                            <Col xs={24} lg={24} xl={24} md={24}>
                                <div className="col_1_div">
                                    <div className="inner_div_col_1">
                                        <div className="client_info">
                                            <div className="inner_client_info">
                                                <p>Client Info</p>
                                                {/*                        <span onClick={() => setModalIsOpen(true)}>*/}
                                                {/*  <PenIconSession />*/}
                                                {/*</span>*/}
                                            </div>
                                            <div className="profile">
                                                <div className="img_div">
                                                    <img src={clientData?.profileImage || DemoImage} />
                                                </div>
                                                <div>
                                                    <p>{clientData?.fullName}</p>
                                                    <p className="para">{clientData?.email}</p>
                                                </div>
                                            </div>
                                            {/*<div className="events_section">*/}
                                            {/*    <div className="inner_events">*/}
                                            {/*        <CalendarIcon />*/}
                                            {/*        <p>Coaching Start</p>*/}
                                            {/*    </div>*/}
                                            {/*    <p>*/}
                                            {/*        {clientData?.lastSession !== null &&*/}
                                            {/*        clientData?.lastSession?.coachingStart*/}
                                            {/*            ? formateDate(*/}
                                            {/*                clientData?.lastSession?.coachingStart*/}
                                            {/*            )*/}
                                            {/*            : "-"}*/}
                                            {/*    </p>*/}
                                            {/*</div>*/}
                                            {/*<div className="events_section">*/}
                                            {/*    <div className="inner_events">*/}
                                            {/*        <CalnedarTickIcon />*/}
                                            {/*        <p>Coaching End</p>*/}
                                            {/*    </div>*/}
                                            {/*    <p>*/}
                                            {/*        {" "}*/}
                                            {/*        {clientData?.lastSession !== null &&*/}
                                            {/*        clientData?.lastSession?.coachingEnd*/}
                                            {/*            ? formateDate(clientData?.lastSession?.coachingEnd)*/}
                                            {/*            : "-"}*/}
                                            {/*    </p>*/}
                                            {/*</div>*/}
                                            <div className="events_section">
                                                <div className="inner_events">
                                                    <CakeIcon />
                                                    <p>Birthday</p>
                                                </div>
                                                <p>
                                                    {clientData?.dob !== "" && clientData?.dob
                                                        ? formateDate(clientData?.dob)
                                                        : "-"}
                                                </p>
                                            </div>
                                            <div className="events_section">
                                                <div className="inner_events">
                                                    <AnniversaryIcon />
                                                    <p>Anniversary</p>
                                                </div>

                                                <p>
                                                    {clientData?.lastSession !== null &&
                                                    clientData?.lastSession?.anniversary
                                                        ? formateDate(clientData?.lastSession?.anniversary)
                                                        : "-"}
                                                </p>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </Col>
                            <Col xs={24} lg={12} xl={12} md={24}>
                                <div className={'col_1_div'}>
                                    <div className={'inner_div_col_1'}>
                                        <div>
                                            <div className={"dfields"}>
                                                <Controller
                                                    name="start_date"
                                                    // defaultValue={"Evan"}
                                                    control={control}
                                                    rules={{
                                                        required: Required,
                                                    }}
                                                    render={({ field: { name, ...field } }) => (
                                                        <ThemeDatePicker
                                                            label={"Coaching Start Date"}
                                                            field={field}
                                                            fieldName={name}
                                                            errors={errors.start_date}
                                                            setValue={setValue}
                                                            // defaultValue={dayjs(
                                                            //     clientData?.lastSession !== null &&
                                                            //     sessionEdit !== null &&
                                                            //     clientData?.lastSession?.coachingStart
                                                            //         ? formateDate(clientData?.lastSession?.coachingStart)
                                                            //         : formateDate(todayData),
                                                            //     "DD/MM/YYYY"
                                                            // )}
                                                        />
                                                    )}
                                                />
                                            </div>
                                            <div className={"dfields"}>
                                                <Controller
                                                    name="end_date"
                                                    // defaultValue={"Evan"}
                                                    control={control}
                                                    rules={{
                                                        required: Required,
                                                    }}
                                                    render={({ field: { name, ...field } }) => (
                                                        <ThemeDatePicker
                                                            label={"Coaching End Date"}
                                                            field={field}
                                                            fieldName={name}
                                                            errors={errors.end_date}
                                                            setValue={setValue}
                                                            // defaultValue={dayjs(
                                                            //     clientData?.lastSession !== null &&
                                                            //     sessionEdit !== null &&
                                                            //     clientData?.lastSession?.coachingEnd
                                                            //         ? formateDate(clientData?.lastSession?.coachingEnd)
                                                            //         : formateDate(todayData),
                                                            //     "DD/MM/YYYY"
                                                            // )}
                                                        />
                                                    )}
                                                />
                                            </div>
                                        </div>
                                        <div className="session_main_div">
                                            <h5>Session Note:</h5>
                                            <div className={"dfields"}>
                                                <Controller
                                                    name="session_note"
                                                    // defaultValue={"Evan"}
                                                    control={control}
                                                    rules={{
                                                        required: Required,
                                                        maxLength: maxLength(2000),
                                                        validate: checkEmptySpaces,
                                                    }}
                                                    render={({ field: { name, ...field } }) => (
                                                        <DescriptionInput
                                                            rows={15}
                                                            autoSize={{ minRows: 15, maxRows: 16 }}
                                                            placeholder={"Write your session notes here..."}
                                                            label={""}
                                                            type={"text"}
                                                            field={field}
                                                            errors={errors.session_note}
                                                            className={"required"}
                                                        />
                                                    )}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className={"dfields d-none d-lg-block"}>
                                    <ThemeButton
                                        text={"Submit"}
                                        className={"btn-light-lg"}
                                        type={"submit"}
                                        loader={loader}
                                    />
                                </div>
                            </Col>
                            <Col xs={24} lg={12} xl={12} md={24}>
                                <div className="col_1_div">
                                    <div className="inner_div_col_1">
                                        <div className="form_div">
                                            <h5>Coach Note</h5>

                                            <div className={"dfields"}>
                                                <Controller
                                                    name="coach_note"
                                                    // defaultValue={"Evan"}
                                                    control={control}
                                                    rules={{
                                                        required: Required,
                                                        maxLength: maxLength(2000),
                                                        validate: checkEmptySpaces,
                                                    }}
                                                    render={({ field: { name, ...field } }) => (
                                                        <DescriptionInput
                                                            rows={10}
                                                            autoSize={{ minRows: 10, maxRows: 11 }}
                                                            placeholder={"Write your coaching notes here..."}
                                                            label={""}
                                                            type={"text"}
                                                            field={field}
                                                            errors={errors.coach_note}
                                                            className={"required"}
                                                        />
                                                    )}
                                                />
                                            </div>
                                        </div>
                                        <div className="form_div">
                                            <h5>Action Items</h5>

                                            <div className={"dfields"}>
                                                <Controller
                                                    name="action_items"
                                                    // defaultValue={"Evan"}
                                                    control={control}
                                                    rules={{
                                                        required: Required,
                                                        maxLength: maxLength(2000),
                                                        validate: checkEmptySpaces,
                                                    }}
                                                    render={({ field: { name, ...field } }) => (
                                                        <DescriptionInput
                                                            rows={10}
                                                            autoSize={{ minRows: 10, maxRows: 11 }}
                                                            placeholder={"Write a action description here..."}
                                                            label={""}
                                                            type={"text"}
                                                            field={field}
                                                            errors={errors.action_items}
                                                            className={"required"}
                                                        />
                                                    )}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className={"dfields d-block d-lg-none"}>
                                    <ThemeButton
                                        text={"Submit"}
                                        className={"btn-light-lg"}
                                        type={"submit"}
                                        loader={loader}
                                    />
                                </div>
                            </Col>
                        </Row>
                    </div>
                </div>
            </Form>
        </>
    );
};

export default AddNote;
